// dashboard/frontend/src/components/Campaign/channels/ChannelFactory.js

/**
 * Channel configuration factory
 * Returns configuration and validation for each channel type
 */
const ChannelFactory = {
    /**
     * Get channel-specific configuration
     */
    getChannelConfig: (channel) => {
        const configs = {
            'email': {
                name: 'Email',
                urlField: 'email',
                hasSubject: true,
                characterLimit: null,
                statusLabels: {
                    draft: 'In Gmail',
                    sent: 'Sent',
                    error: 'Error',
                }
            },
            'instagram_dm': {
                name: 'Instagram DM',
                urlField: 'instagram_url',
                hasSubject: false,
                characterLimit: 1000,
                statusLabels: {
                    draft: 'Ready to Send',
                    sent: 'Sent',
                    error: 'Error',
                }
            },
            'twitter_dm': {
                name: 'Twitter DM',
                urlField: 'twitter_url',
                hasSubject: false,
                characterLimit: 10000,
                statusLabels: {
                    draft: 'Ready to Send',
                    sent: 'Sent',
                    error: 'Error',
                }
            },
            'linkedin_dm': {
                name: 'LinkedIn DM',
                urlField: 'linkedin_url',
                hasSubject: false,
                characterLimit: 8000,
                statusLabels: {
                    draft: 'Ready to Send',
                    sent: 'Sent',
                    error: 'Error',
                }
            }
        };

        return configs[channel] || null;
    },

    /**
     * Validate if contact has required info for channel
     */
    validateContactForChannel: (contact, channel) => {
        const config = ChannelFactory.getChannelConfig(channel);
        if (!config) return false;

        const value = contact[config.urlField];
        return value && value.trim() !== '';
    }
};

export default ChannelFactory;